/* unplugin-vue-components disabled */import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-cd91d9b2"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  class: "bg"
};
var _hoisted_3 = {
  style: {
    "text-align": "center",
    "margin-top": "20px"
  }
};
var _hoisted_4 = {
  key: 1,
  class: "fixedInfo"
};
var _hoisted_5 = {
  class: "main"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "添加维修记录", -1);
});
var _hoisted_7 = {
  style: {
    "padding": "20px 10px"
  }
};
var _hoisted_8 = {
  class: "row"
};
var _hoisted_9 = {
  class: "row"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "维修内容：", -1);
});
var _hoisted_11 = {
  class: "row"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "维修结果：", -1);
});
var _hoisted_13 = {
  class: "row"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "维修人员：", -1);
});
var _hoisted_15 = {
  class: "row"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "备注信息：", -1);
});
import hyRequest from '@/service';
import { Step, Steps, showToast } from 'vant';
export default {
  __name: 'Repair',
  setup: function setup(__props) {
    var device_id = useRoute().query.device_id;
    var device_name = useRoute().query.deviceName;
    var List = ref([]);
    function getData() {
      hyRequest.post({
        url: '/repair/deviceRepairRecordByFactoryDevice',
        data: {
          device_id: device_id,
          pageNumber: 1,
          pageSize: 20000
        }
      }).then(function (data) {
        console.log(data.list);
        List.value = data.list;
      });
    }
    getData();
    var show = ref(false);
    var saveType = ref('insert');
    var form = reactive({
      id: '',
      device_id: device_id,
      device_name: device_name,
      check_result_id: '',
      repair_info: '',
      remark: ''
    });

    // function edit(item) {
    //   saveType.value = 'update';
    //   form.id = item.id;
    //   form.info = item.info;
    //   form.remark = item.remark;
    //   defaultDay.value = dayjs(item.next_time).toDate();
    //   show.value = true;
    // }

    // function remove(id) {
    //   console.log(id);
    //   hyRequest
    //     .post({
    //       url: '/repair/maintainDel',
    //       data: {
    //         id
    //       }
    //     })
    //     .then(() => {
    //       showToast('删除成功！');
    //       getData();
    //     });
    // }

    function openDialog() {
      form.next_time = '';
      form.info = '';
      form.remark = '';
      show.value = true;
      saveType.value = 'insert';
    }

    // const defaultDay = ref(dayjs().toDate());
    var columns = reactive([]);
    var chooseColumns = ref('');
    var showPicker = ref(false);
    function getColums() {
      hyRequest.post({
        url: '/repair/deviceRepairItem',
        data: {
          device_id: device_id
        }
      }).then(function (data) {
        columns.push.apply(columns, _toConsumableArray(data.list));
      });
    }
    getColums();
    function onConfirm(e) {
      console.log(e);
      form.check_result_id = e.id;
      chooseColumns.value = e.check_point_result;
      showPicker.value = false;
    }
    function cancel() {
      show.value = false;
    }
    function saveData() {
      if (chooseColumns.value == '') {
        return showToast('请设置维修结果');
      }
      var url = '';
      if (saveType.value == 'insert') {
        url = '/repair/deviceRepairAdd';
      } else {
        url = '/repair/deviceRepairItemModfiy';
      }
      hyRequest.post({
        url: url,
        data: form
      }).then(function () {
        show.value = false;
        showToast('保存成功');
        getData();
      });
    }
    if (useRoute().query.add == 1) {
      openDialog();
    }
    return function (_ctx, _cache) {
      var _component_van_button = _resolveComponent("van-button");
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_cell_group = _resolveComponent("van-cell-group");
      var _component_van_icon = _resolveComponent("van-icon");
      var _component_van_picker = _resolveComponent("van-picker");
      var _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", null, [_unref(show) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "wrapper",
        onClick: _cache[4] || (_cache[4] = _withModifiers(function () {}, ["stop"]))
      }, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_cell_group, {
        border: false
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            modelValue: _unref(chooseColumns),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _isRef(chooseColumns) ? chooseColumns.value = $event : null;
            }),
            label: "维修结果",
            "label-width": "auto",
            autocomplete: "off",
            colon: "",
            type: "textarea",
            readonly: "",
            placeholder: "请设置维修结果"
          }, {
            button: _withCtx(function () {
              return [_createVNode(_component_van_button, {
                size: "mini",
                icon: "add-o",
                type: "primary",
                plain: "",
                style: {
                  "position": "absolute",
                  "top": "0",
                  "right": "0"
                },
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return showPicker.value = true;
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("选择结果")];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        border: false
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            modelValue: _unref(form).repair_info,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return _unref(form).repair_info = $event;
            }),
            label: "维修内容",
            "label-width": "auto",
            colon: "",
            type: "textarea",
            autocomplete: "off",
            placeholder: "请输入维修内容"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        border: false
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            modelValue: _unref(form).remark,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return _unref(form).remark = $event;
            }),
            label: "备注信息",
            autocomplete: "off",
            "label-width": "auto",
            colon: "",
            type: "textarea",
            placeholder: "请输入备注信息"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_button, {
        type: "warning",
        size: "small",
        onClick: cancel,
        style: {
          "width": "80px"
        }
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("取消")];
        }),
        _: 1
      }), _createVNode(_component_van_button, {
        type: "primary",
        size: "small",
        style: {
          "margin-left": "40px",
          "width": "80px"
        },
        onClick: saveData
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("保存")];
        }),
        _: 1
      })])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "btn",
        onClick: openDialog
      }, [_createVNode(_component_van_icon, {
        name: "add-o",
        size: "15"
      }), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createVNode(_unref(Steps), {
        direction: "vertical",
        "active-color": "#969799",
        "inactive-icon": "passed",
        "active-icon": "passed"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(List), function (item, index) {
            return _openBlock(), _createBlock(_unref(Step), {
              key: index
            }, {
              "inactive-icon": _withCtx(function () {
                return [_createVNode(_component_van_icon, {
                  name: "shield-o",
                  size: "20",
                  color: "#4485f3"
                })];
              }),
              "active-icon": _withCtx(function () {
                return [_createVNode(_component_van_icon, {
                  name: "shield-o",
                  size: "20",
                  color: "#4485f3"
                })];
              }),
              default: _withCtx(function () {
                var _item$remark;
                return [_createElementVNode("div", _hoisted_8, [_createElementVNode("b", null, _toDisplayString(item.create_time), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(item.repair_info), 1)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(item.check_point_result), 1)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("span", null, _toDisplayString(item.check_persion), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", null, _toDisplayString((_item$remark = item.remark) !== null && _item$remark !== void 0 ? _item$remark : '-'), 1)])];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      })])])])), _createVNode(_component_van_popup, {
        show: _unref(showPicker),
        "onUpdate:show": _cache[6] || (_cache[6] = function ($event) {
          return _isRef(showPicker) ? showPicker.value = $event : null;
        }),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_picker, {
            columns: _unref(columns),
            "columns-field-names": {
              text: 'check_point_result',
              value: 'id'
            },
            onCancel: _cache[5] || (_cache[5] = function ($event) {
              return showPicker.value = false;
            }),
            onConfirm: onConfirm
          }, null, 8, ["columns"])];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
};